export const SLICE_NAME = 'clientSurveysPage';
export const SORTING_FIELD = 'date';
